import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { store } from "./app/store";

import "./index.scss";
import "react-toastify/dist/ReactToastify.css";
import { DarkModeProvider } from "./utils/Context/DarkModeContext";

// Suppress benign ResizeObserver warnings/errors in dev overlays
window.addEventListener("error", (e) => {
  if (e.message && (e.message.includes("ResizeObserver") || e.message.includes("Resize observer"))) {
    e.stopImmediatePropagation();
  }
});


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
      <ToastContainer autoClose={3000} />
      <DarkModeProvider>
        <App />
      </DarkModeProvider>
  </Provider>
);
reportWebVitals();
